module.exports = __webpack_public_path__ + "img/icon-sort.2bd64a8e.svg";